import React, { FC } from 'react';
import { toAbsoluteUrl } from '../../utils';
import { WhisperComponent } from '../developers/page-components/WhisperComponent';

interface Props {
	cardBrands: string;
}

export const ProviderCardBrands: FC<Props> = (props) => {
	const { cardBrands } = props;
	const cardArr = cardBrands?.split(',');

	const cardIcons = cardArr?.map(el => {
		switch (el) {
			case 'Visa': return ({ alt: el, src: '/media/icons/visa.svg' });
			case 'MasterCard': return ({ alt: el, src: '/media/icons/mastercard.svg' });
			case 'Amex': return ({ alt: el, src: '/media/icons/amex.svg' });
			case 'Discover': return ({ alt: el, src: '/media/icons/discover.svg' });
			case 'DinersClub': return ({ alt: el, src: '/media/icons/diners.svg' });
			case 'JCB': return ({ alt: el, src: '/media/icons/jcb.svg' });
			case 'Maestro': return ({ alt: el, src: '/media/icons/maestro.svg' });
			case 'UnionPay': return ({ alt: el, src: '/media/icons/unionpay.svg' });
			default: return ({ alt: el, src: '/media/icons/credit-card-regular.svg' });
		}
	});

	return (
		<div className="fc-text-overflow">
			{cardIcons?.map(el => (
				<WhisperComponent
					key={el?.alt}
					isTooltip
					whisperText={el?.alt}
					mainText={
						<img
							className="me-1"
							src={toAbsoluteUrl(el?.src)}
							height={17}
							width={20}
							alt={el?.alt}
						/>
					}
				/>
			))}
		</div>
	);
};
